import createStorage from './storageBase';

const fakeStorageSymbol = Symbol('fake-local-storage');

export default createStorage('localStorage', fakeStorageSymbol);
